export interface ShipmentDocument {
  shipmentDocumentId?: string;
  shipmentDocumentName?: string;
  vendorId: string;
  carrierId: string;
  packingSlip: string;
  purchaseOrderNumber: string;
  vppCo?: number;
  vppoKeyId?: number;
}

export interface ShipmentDocumentItem {
  shipmentDocumentItemId?: string;
  itemId?: string;
  quantity: number;
  warehouseId: string;
  warehouseName: string;
  initialSubLocationId: string;
  subLocationName: string;
  isFinalLocation: boolean;
  itemCode: string;
  isUnique: boolean;
  itemDescription: string;
  itemTypeId: string;
  itemTypeName: string;
  unitOfMeasureId?: string;
  shipmentDocumentItemStatusId?: string;
  shipmentDocumentItemStatusName?: string;
  receiveDate?: Date | string;
  notes?: string;
  requisitionNotes?: string[];
}

export interface ShipmentDocumentStatus {
  statusId: string;
  statusName: string;
}
